import { getCurrentApp } from "./get-current-app.ts";
import { getInjectedConfig } from "./get-injected-config.ts";

/**
 * Redirect the browser to the appropriate login flow when an authenticated
 * request fails. JWT handoff tenants centralize unauthenticated entry on the
 * root path — sending the user to "/" lets the root-path guard in `Router.tsx`
 * bounce them out to the configured IdP. OIDC tenants go directly to their
 * OIDC login page. Anything else falls back to the generic error page.
 *
 * The decision uses the injected fan config instead of any client-side allow
 * list — see ADR-0005.
 */
export function redirectToLogin() {
  const config = getInjectedConfig();
  const app = config?.app.slug ?? getCurrentApp();

  if (config?.auth.jwtHandoff) {
    window.location.replace(new URL("/", window.location.origin));
    return;
  }

  if (app && config?.auth.oidcEnabled) {
    const loginURL = new URL(`/login/oidc/${app}`, window.location.origin);
    loginURL.searchParams.set("redirectTo", window.location.pathname);

    window.location.replace(loginURL);
    return;
  }

  redirectToErrorPage();
}

export function redirectToErrorPage() {
  const errorURL = new URL("/error", window.location.origin);
  window.location.replace(errorURL);
}
